import { ActionButton } from "@tandemdiabetes/sugarmate-react-components"
import { useCallback } from "react"

import styles from "./TrackingTechnologyConsentPage.module.scss"

import {
  Logo,
  Page,
  PolicyViewerLink,
} from "src/components"
import { usePolyglot } from "src/contexts"
import { useTrackingTechnologyConsentDocument } from "src/hooks"
import type { TrackingTechnologyConsentResponse } from "src/types"

const polyglotPrefix = "pages.tracking_technology_consent."

interface Props {
  setResponse: (v: TrackingTechnologyConsentResponse["value"]) => void;
}

export function TrackingTechnologyConsentPage(props: Props) {
  const { setResponse } = props
  const polyglot = usePolyglot()

  const { data: trackingTechnologyConsentDocument } = useTrackingTechnologyConsentDocument()
  const accept = useCallback(
    () => {
      setResponse("accepted")
    },
    [setResponse],
  )

  const reject = useCallback(
    () => {
      setResponse("rejected")
    },
    [setResponse],
  )

  return (
    <Page>
      <div className={styles.container}>
        <Logo className={styles.logo} />
        <div className={styles.heading}>
          {polyglot.t(`${polyglotPrefix}title`)}
        </div>
        <div className={styles.text}>
          {polyglot.t(
            `${polyglotPrefix}description`,
            {
              link: (
                <PolicyViewerLink
                  policyDocument={trackingTechnologyConsentDocument}
                  policyDocumentName="tracking-technology"
                >
                  {polyglot.t(`${polyglotPrefix}link_text`)}
                </PolicyViewerLink>
              ),
            },
          )}
        </div>
        <div className={styles.buttonsContainer}>
          <ActionButton
            stylePreset="secondary"
            onClick={accept}
          >
            {polyglot.t(`${polyglotPrefix}accept_cta`)}
          </ActionButton>
          <ActionButton
            stylePreset="secondary"
            onClick={reject}
          >
            {polyglot.t(`${polyglotPrefix}reject_cta`)}
          </ActionButton>
        </div>
        <button
          className={styles.skip}
          onClick={reject}
        >
          {polyglot.t(`${polyglotPrefix}skip_cta`)}
        </button>
      </div>
    </Page>
  )
}
